//? common
import {
  BlackListedIcon,
  CancelIcon,
  CashPendingAtCollector,
  CashPendingAtPartner,
  DeliveryPending,
  DispatchedIcon,
  DispatchPendingIcon,
  InProgressIcon,
  New,
  OrderReturn,
  PackedIcon,
  PackingInProgressIcon,
  PaymentPendingIcon,
  PaymentUnderVerificationIcon,
  PendingForRefund,
  PendingIcon,
  PODPending,
  Received,
  Refund,
  ReUpload,
  Sent,
  UpdateIcon1,
  Upload,
  Urgent,
} from "../components/icons/Icon";
import { AllCount, Deleted, Verified } from "../components/icons/Icon2";

const statusIcons = {
  New: <New />,
  "New Order": <New />,
  Pending: <PendingIcon />,
  Disable: <BlackListedIcon />,
  Blacklisted: <BlackListedIcon />,
  Disabled: <BlackListedIcon />,
  All: <AllCount />,
  Active: <Verified />,
  Verified: <Verified />,
  Completed: <Verified />,
  Update: <UpdateIcon1 />,
  Deleted: <Deleted />,
  Cancelled: <CancelIcon />,
  Closed: <CancelIcon />,
  Rejected: <CancelIcon />,
  "In Progress": <InProgressIcon />,
  Packed: <PackedIcon />,
  "Payment Pending": <PaymentPendingIcon />,
  "Delivery Pending": <DeliveryPending />,
  "Payment Under Verification": <PaymentUnderVerificationIcon />,
  "Pending For Verification": <PaymentUnderVerificationIcon />,
  "Packing In Progress": <PackingInProgressIcon />,
  "Dispatched Pending": <DispatchPendingIcon />,
  Dispatched: <DispatchedIcon />,
  Refund: <Refund />,
  "Pending For Refund": <PendingForRefund />,
  "POD Pending": <PODPending />,
  "Pending at Partner": <CashPendingAtPartner />,
  "Pending at Collector": <CashPendingAtCollector />,
  Received: <Received />,
  Uploaded: <Upload />,
  OrderReturn: <OrderReturn />,
  "Order Return": <OrderReturn />,
  Reupload: <ReUpload />,
  Urgent: <Urgent />,
  "Re Upload": <ReUpload />,
  Sent: <Sent />,
};

const daysData = [
  { value: "today", label: "Today" },
  { value: "yesterday", label: "Yesterday" },
  { value: "month", label: "This Month" },
  { value: "period", label: "Period" },
];

const yearData = [
  { label: "2025-2026", value: 1 },
  { label: "2024-2025", value: 2 },
  { label: "2023-2024", value: 3 },
  { label: "2022-2023", value: 4 },
  { label: "2021-2022", value: 5 },
];

//? invoice
const invoiceDashboardHeader = [
  "check",
  "Order Date",
  "Order ID",
  "Name & City & ID",
  "Amount",
  "Order Status",
  "Status",
  "Last Action",
];

const invoiceFilterData = [
  {
    status: "All",
    label: "All",
    count: 0,
  },
  // {
  //   status: "Cancelled",
  //   label: "Cancelled",
  //   count: 0,
  // },
  {
    status: "Pending",
    label: "Pending",
    count: 0,
  },
  // {
  //   status: "Uploaded",
  //   label: "Uploaded",
  //   count: 0,
  // },
  // {
  //   status: "Reupload",
  //   label: "Re Upload",
  //   count: 0,
  // },
  // {
  //   status: "OrderReturn",
  //   label: "Order Return",
  //   count: 0,
  // },
  {
    status: "Urgent",
    label: "Urgent",
    count: 0,
  },
  {
    status: "Completed",
    label: "Completed",
    count: 0,
  },
];

//? dispatch
const packingVoucherHeader = [
  "S.No",
  "Item No",
  "Product",
  "Warehouse",
  "Quantity",
  "Unit",
];

//? marketing/leads
const leadTypeData = [
  { value: "all", label: "All" },
  { value: "wholesale", label: "Wholesale" },
  { value: "retail", label: "Retail" },
];

const marketingFilterData = [
  {
    status: "All",
    label: "All",
    count: 0,
  },
  {
    status: "New",
    label: "New",
    count: 0,
  },
  {
    status: "Pending",
    label: "Pending",
    count: 0,
  },
  {
    status: "Sent",
    label: "Sent",
    count: 0,
  },
  {
    status: "Closed",
    label: "Closed",
    count: 0,
  },
  {
    status: "Completed",
    label: "Completed",
    count: 0,
  },
];

const leadHistoryData = [
  "S No",
  "Name",
  "Company",
  "Address",
  "First Shared",
  "Last Shared",
  "Share Count",
];

const timeStampsData = [
  { value: "updatedAt", label: "Updated At" },
  { value: "createdAt", label: "Created At" },
];

//? order
const orderTypeData = [
  "Order",
  "Collection",
  "Purchase",
  "Adjustment",
  "Transfer",
  "Production",
  "Production & Sale",
  "Production & Transfer",
];

const transferOrderHeader = [
  "Date",
  "Voucher No",
  "From Warehouse",
  "To Warehouse",
  "Amount",
  "Status",
  "Items",
];

const adjustmentOrderHeader = [
  "Date",
  "Voucher No.",
  "Warehouse",
  "Amount",
  "Status",
  "Items",
];

const purchaseOrderHeader = [
  "Date",
  "Voucher No.",
  "Vendors Name",
  "Warehouse",
  "Amount",
  "Status",
  "Items",
];

const orderHeader = [
  "Date & Time",
  "Order ID",
  "Name & City",
  "Shipping Type",
  "Created By",
  "Order Manager",
  "Source",
  "Amount",
  "Status",
  "Last Action",
];

//? receipts
const receiptHeader = [
  "ID & Date & Time",
  "Order ID",
  "Name & City & ID",
  "Created By",
  "Order Manager",
  "Dispatched",
  "Delivery Partner",
  "Amount",
  "Method",
  "Status",
  "Receiver",
  "Last Action",
];

const receiptMethodType = [
  { value: "", label: "All" },
  { value: "Cash", label: "Cash" },
  { value: "POD", label: "POD" },
];

//? dispatch
const dispatchHeader = [
  "Date & Time",
  "Order ID",
  "Name & City & ID",
  "Created By",
  "Order Manager",
  "Packer",
  "Source",
  "Sub Method",
  "Pending Amount",
  "Delivery Partner",
  "Status",
  "Last Action",
];

//? used by OM
const MeOptions = ["All", "Me"];

export {
  statusIcons,
  daysData,
  yearData,
  invoiceDashboardHeader,
  invoiceFilterData,
  packingVoucherHeader,
  leadTypeData,
  marketingFilterData,
  leadHistoryData,
  timeStampsData,
  orderTypeData,
  transferOrderHeader,
  adjustmentOrderHeader,
  purchaseOrderHeader,
  orderHeader,
  receiptHeader,
  receiptMethodType,
  dispatchHeader,
  MeOptions,
};
